<template>
  <button :class="$style.button" :disabled="disabled" @click="$emit('click')">
    Войти
  </button>
</template>

<script></script>

<style lang="scss" module>
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  width: 100%;
  outline: 0;
  height: 3.25rem;
  border-radius: 0.25rem;
  transition: all 0.3s ease-in-out;
  border: 1px solid transparent;
  color: $t-secondary;
  @include ButtonText;
  background-color: $bg-primary;
  &:hover {
    background-color: $t-primary;
    color: $bg-main;
  }
}
</style>
